import elephantLogomark from "$assets/elephant-logomark.svg?url";
import { useAuth0 } from "@auth0/auth0-react";
import { AppBar, Box, styled, Toolbar, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { linkToEpocusHome, linkToEpocusSettings } from "../links";
import { EpocusAvatar } from "./epocus-avatar";
import {
  EPOCUS_BORDER,
  EPOCUS_ICON_ACTIVE,
  EPOCUS_WHITE,
  rem,
} from "./epocus-palette";
import { epocusTheme } from "./epocus-theme-provider";

const LogoBox = styled(Box)({
  width: 32,
  height: 32,
  borderRadius: 8,
  backgroundColor: EPOCUS_ICON_ACTIVE,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

const LogoImg = styled("img")({
  width: 20,
  height: 20,
  filter: "brightness(0) invert(1)",
});

const BrandGroup = styled(Link)({
  display: "flex",
  alignItems: "center",
  gap: 10,
  textDecoration: "none",
  color: "inherit",
  cursor: "pointer",
});

const AppName = styled(Typography)({
  color: EPOCUS_ICON_ACTIVE,
  fontWeight: 700,
  fontSize: rem(20),
});

const SettingsLink = styled(Link)({
  display: "inline-flex",
  textDecoration: "none",
  cursor: "pointer",
});

const BAR = {
  backgroundColor: EPOCUS_WHITE,
  boxShadow: `0 1px 0 0 ${EPOCUS_BORDER}`,
  color: "inherit",
  "& .MuiToolbar-root": {
    minHeight: 56,
    gap: 12,
  },
} as const;

const StyledAppBar = styled(AppBar)({
  ...BAR,
  // Sidebar replaces header on tablet+
  [epocusTheme.breakpoints.up("sm")]: {
    display: "none",
  },
});

const PersistentAppBar = styled(AppBar)({ ...BAR });

export const EpocusHeader: FC<{ persistent?: boolean }> = ({ persistent }) => {
  const { user } = useAuth0();
  const Bar = persistent ? PersistentAppBar : StyledAppBar;

  return (
    <Bar position="sticky" elevation={0}>
      <Toolbar>
        <BrandGroup to={linkToEpocusHome()} aria-label="Go to home">
          <LogoBox>
            <LogoImg src={elephantLogomark} alt="" />
          </LogoBox>
          <AppName variant="h6">ePOCUS</AppName>
        </BrandGroup>
        <Box flex={1} />
        <SettingsLink to={linkToEpocusSettings()} aria-label="Open settings">
          <EpocusAvatar name={user?.name} size={36} />
        </SettingsLink>
      </Toolbar>
    </Bar>
  );
};
